// @flow

import { type OutgoingPayment } from '../outgoing-payment/types';

export async function webpayOutgoingPaymentMapper(): Promise<$Shape<OutgoingPayment>> {

  return {
    payment_type: 'webpay',
    payment_type_code: 'webpay',
    instalments: '1',
  };
}
